
import { client } from '../../../core/api/client';
import {
  MemberSignupRequest,
  SendVerificationCodeRequest,
  SendVerificationCodeResponse,
  VerifyCodeResponse,
} from '../types/account';
import * as FullStory from '@fullstory/browser';

export const ACCOUNTS_BASE_API_ENDPOINT = '/api/v1/accounts';

export const postSendVerificationCode = (payload: SendVerificationCodeRequest, 
signal?: AbortSignal) => {
  return client.post<SendVerificationCodeResponse>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member/send-code`,
    payload,
    { signal }
  );
};

export const postVerifyMFACode = (memberId: string, code: string, 
signal?: AbortSignal) => {
  return client.post<VerifyCodeResponse>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member/${memberId}/verify-code`,
    { code },
    { signal }
  );
};

export const postMemberSignup = (payload: MemberSignupRequest, 
signal?: AbortSignal) => {
  return client.post<SendVerificationCodeResponse>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member-signup`,
    payload,
    { signal }
  );
};

export const postVerifyPhone = (memberId: string, code: string, 
signal?: AbortSignal) => {
  // Backend now returns accessToken + profile + subscription after phone verify
  // (email OTP step removed), so we use VerifyCodeResponse.
  return client.post<VerifyCodeResponse>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member/${memberId}/verify-phone-number`,
    { code },
    { signal }
  );
};

export const postSendEmailVerificationCode = (memberId: string, email: string, 
signal?: AbortSignal) => {
  return client.post<{statusCode: number, message: string}>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member/${memberId}/send-email-verification`,
    { email },
    { signal }
  );
};

export const postCompleteSignUpVerification = (memberId: string, code: string, 
signal?: AbortSignal) => {
  return client.post<VerifyCodeResponse>(
    `${ACCOUNTS_BASE_API_ENDPOINT}/member/${memberId}/complete-signup-verification`,
    { code },
    { signal }
  );
};

export const setFullStoryIdentity = (user:any) => {

  if ( !FullStory  || !FullStory?.isInitialized) {
    return;
  }

  if (user) {
    const fullName = user.firstName!==undefined? `${user.firstName} ${user.lastName}`:'';


  
    let displayName1 = fullName.trim()!==''?fullName:user.phoneNumber||user.phone;


    
    FullStory.FullStory('setIdentity',{uid:user.userId, properties:{
      displayName:displayName1 +'- mindright-portal',
      email: user.email,
      userType: 'student',
      environment: 'production',  
      phoneNumber: user.phoneNumber || user.phone ,      

       appName: 'mindright-portal',
    }});
    
   
  } else {
    FullStory?.FullStory('setIdentity', { uid: '', properties: {} });
  }
  return;
  };